<template>
 <Main class="mt-20">
  <sdModal :onCancel="handleFileUploadCancel" :visible="showFileUploadRef" title="Document uploaden" type="primary">
   <ModalMain>
    <div class="create-account-form">
     <a-form :model="fileUpload" layout="vertical" @finish="handleUpload">
      <a-row :gutter="30">
       <a-col :xs="24">
        <div class="clearfix">
         <a-upload-dragger :before-upload="beforeUpload" :file-list="fileList" :remove="handleFileRemove"
                           multiple="false">
          <a-button :disabled="fileList.length === 1">
           <upload-outlined></upload-outlined>
           Selecteer bestand
          </a-button>
         </a-upload-dragger>
        </div>
       </a-col>
       <a-col
        :xs="24"
       >
        <a-button
         :disabled="fileList.length === 0"
         :loading="loadingFileUpload"
         html-type="submit"
         size="large"
         style="margin-top: 16px"
         type="primary"
        >
         {{ uploading ? 'Uploading' : 'Start Upload' }}
        </a-button>
       </a-col>
      </a-row>
     </a-form>
    </div>
   </ModalMain>
  </sdModal>
  <a-row v-if="loadingOffer" :gutter="30">
   <a-col :xs="24">
    <div class="spin">
     <a-spin/>
    </div>
   </a-col>
  </a-row>
  <a-row v-visible="!loadingOffer" v-if="loadingOffer || (!loadingOffer && !loadingOfferError)" :gutter="30">

   <a-col :md="12" :xs="24" v-if="!offer?.isSignable && offer?.isExpired">
    <sdCards headless>
     Geachte {{ offer?.relation?.fullName }},<br>
     <br>
     Hartelijk dank voor je offerte aanvraag, helaas is dit aanbod verlopen. Neem contact op voor een nieuw aanbod.
    </sdCards>
   </a-col>
   <a-col :md="12" :xs="24" v-if="!offer?.isSignable && offer?.isSigned">
    <sdCards headless>
     <div v-html="afterSigningText"></div>

     <!-- Betaalknop voor producten die kunnen betalen en nog niet betaald zijn -->
     <a-button
       v-if="offer?.product?.canPay && offer?.canPay && !offer?.hasPaid"
       size="large"
       class="btn-signin mt-5"
       type="primary"
       :loading="loadingPayOffer"
       :disabled="loadingPayOffer"
       @click.prevent="pay">
       Betalen
     </a-button>
    </sdCards>
   </a-col>
   <a-col :md="12" :xs="24" v-if="offer?.isSignable">
    <sdCards headless>
     <div v-html="beforeSigningText"></div>
    </sdCards>

    <Aom v-if="!loadingOffer && offer?.energyCalculation && offer?.type === 'ENERGY' && !offer?.product.isProxy"
         :calculations="offer.energyCalculation" :type="offer?.energyCalculation?.product?.allowedCustomerType"/>

    <sdCards title="Foto's uploaden" v-if="offer?.type === 'SOLAR' && offer?.isSigned">
     <section>
      Om de plaatsing van uw panelen soepeler te laten verlopen vragen wij u om foto’s van het volgende te
      uploaden:<br/>
      <ul style="list-style: square;padding-left: 20px">
       <li>Een duidelijke foto van uw dak waar u de panelen zou willen hebben.</li>
       <li>Een duidelijke foto van de meterkast waar de meter ook goed zichtbaar is.</li>
       <li>Een detailfoto van de stroommeter van de netbeheerder.</li>
      </ul>
     </section>
     <!--          <FilesListTable/>-->
     <a-row class="mt-6">
      <a-col :sm="12" :xs="24">
       <div class="sDash_form-action">
        <a-button class="btn-signin" size="large" type="primary" @click.prevent="showFileUpload">
         Toevoegen
        </a-button>
       </div>
      </a-col>
     </a-row>
    </sdCards>

    <sdCards title="Documenten" v-if="offer?.product?.files?.length > 0 && offer?.type !== 'SOLARCONFIRM'">
     <div v-for="(item,index) in offer?.product?.files" :key="index">
      <a :href="item?.fileURL" class="w-100">
       &#x2022; {{ item?.name }}
      </a>
     </div>
    </sdCards>
    <a-form :model="offer" layout="vertical" @finish="signOffer">
     <sdCards title="Ondertekenen">
      <a-row :gutter="30"
             v-if="(offer?.product?.customerApprovals.length > 0 && offer?.type !== 'SOLARCONFIRM' )|| offer?.product.isProxy">
       <a-col :xs="24" class="mb-5">
        <CheckListWrap>
         <div class="sDash_check-list-wrap">
          <ul class="sDash_check-list sDash_check-list--left">
           <li v-for="(item,index) in offer?.product?.customerApprovals" :key="index" style="margin-bottom: 0px">
            <a-form-item label="" :name="['product','customerApprovalsValidation', index]"
                         :rules="{ validator: checkCheckBox }" style="margin-bottom: 0px">
             <a-checkbox v-model:checked="offer.product.customerApprovalsValidation[index]"
                         :name="['product','customerApprovalsValidation', index]">
              <span style="color:#000000" v-html="item"></span>
             </a-checkbox>
            </a-form-item>
           </li>
          </ul>
         </div>
        </CheckListWrap>
       </a-col>
       <a-col
        v-if="!loadingOffer && ((offer?.type !== 'SOLARSIMPLE' && offer?.type !== 'SOLAR' && offer?.type !== 'SHOP' && offer?.type !== 'SUSTAINABILITYCONSULTATION' && offer?.type !== 'SUSTAINABILITYWITHPRODUCT') || offer?.product.isProxy)"
        :md="12" :xs="24" class="mb-5">
        <a-form-item label="IBAN" :name="['relation','bankAccountNumber']"
                     :rules="{required: true,message: 'Dit veld is verplicht'}">
         <a-input v-model:value="offer.relation.bankAccountNumber" :name="['relation','bankAccountNumber']"
                  placeholder=""/>
        </a-form-item>
       </a-col>
       <a-col
        v-if="!loadingOffer && ((offer?.type !== 'SOLARSIMPLE' && offer?.type !== 'SOLAR' && offer?.type !== 'SHOP' && offer?.type !== 'SUSTAINABILITYCONSULTATION' && offer?.type !== 'SUSTAINABILITYWITHPRODUCT') || offer?.product.isProxy)"
        :md="12" :xs="24" class="mb-5">
        <a-form-item label="Tenaamstelling" :name="['relation','debtorName']"
                     :rules="{required: true,message: 'Dit veld is verplicht'}">
         <a-input v-model:value="offer.relation.debtorName" :name="['relation','debtorName']" placeholder=""/>
        </a-form-item>
       </a-col>
      </a-row>
      <a-row :gutter="30">
       <a-col :xs="24" class="signature align-center" v-if="offer?.eSignatureType === 'WET'">
        <Vue3Signature ref="signature1" :sigOption="sigState.option" :w="'450px'" :h="'200px'"
                       :disabled="sigState.disabled" @change="alert('2')"></Vue3Signature>
        <div v-if="signatureError" class="ant-form-item-explain ant-form-item-explain-error">
         <div role="alert">Uw handtekening is vereist</div>
        </div>
        <a-button size="large" class="btn-signin mt-5" type="default" @click.prevent="clearSignature"> Opnieuw
        </a-button>
       </a-col>
      </a-row>
     </sdCards>
     <sdCards>
      <a-row>
       <a-col :sm="12" :xs="24">
        <div class="sDash_form-action">
         <a-button v-if="offer?.product.name === 'Centrum voor Noodstroomvoorziening Minicube'" size="large" class="btn-signin" type="primary" html-type="submit" :loading="loadingSignOffer"
                   :disabled="loadingSignOffer" @click="validateSignature" > Bestel met betaalverplichting
         </a-button>
         <a-button v-else size="large" class="btn-signin" type="primary" html-type="submit" :loading="loadingSignOffer"
                   :disabled="loadingSignOffer" @click="validateSignature" > Accorderen
         </a-button>
         <!--                <a-button size="large" class="btn-signin ml-5" type="danger" html-type="submit" :loading="loadingSignOffer"-->
         <!--                          :disabled="loadingSignOffer"> Weigeren-->
         <!--                </a-button>-->
        </div>
       </a-col>
      </a-row>
     </sdCards>
    </a-form>
   </a-col>
   <a-col :md="12" :xs="24">
    <div
     id="adobe-dc-view"
     style="width: 100%; box-shadow: 1px 1px 10px 1px #dadada;display: flex;height:90vh;flex-flow: column;"
    />

   </a-col>
  </a-row>
  <a-row v-if="!loadingOffer && loadingOfferError" :gutter="30">
   <a-col :md="12" :xs="24">
    <sdCards headless>
     Geachte Heer/Mevrouw,<br>
     <br>
     Deze link waarmee je deze pagina probeert te bezoeken is incorrect of mogelijk verlopen. Contacteer de
     klantenservice voor meer informatie.
    </sdCards>
   </a-col>
  </a-row>
 </Main>
</template>
<script>
import {computed, defineComponent, onBeforeUnmount, onMounted, reactive, ref} from 'vue';
import {CheckListWrap, Main} from '../styled';
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import Aom from "../../components/aom/Aom";
// import FilesListTable from "./component/FilesTable.vue";
import {checkCheckBox} from "../../utility/validators";

const Sign = defineComponent({
 name: 'Sign',
 components: {Main, Aom, CheckListWrap},
 data() {
  return {
   showEditDrawer: false,
  }
 },
 setup() {
  const {state, dispatch} = useStore();
  const {params} = useRoute();
  const offer = reactive(computed(() => state.customer.offer));
  const loadingOffer = reactive(computed(() => state.customer.loadingOffer));
  const loadingSignOffer = reactive(computed(() => state.customer.loadingSignOffer));
  const loadingOfferError = reactive(computed(() => state.customer.loadingOfferError));
  const loadingFileUpload = reactive(computed(() => state.file.loadingFileUpload));
  const loadingPayOffer = reactive(computed(() => state.customer.loadingPayOffer));
  const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
  const signatureError = ref(false);
  const showFileUploadRef = ref(false);
  const fileList = ref([]);
  const fileUpload = ref(
   {
    type: 'CUSTOMERUPLOAD',
   }
  );
  const sigState = reactive({
   count: 0,
   option: {
    penColor: "rgb(0, 0, 0)",
    backgroundColor: "rgb(220,220,220)",
   },
   disabled: false
  })

  const approvals = ref([]);

  const signature1 = ref()

  // Computed properties voor sign page teksten uit product
  const beforeSigningText = computed(() => {
   return offer?.value?.product?.signPageTexts?.beforeSigning || '';
  });

  const afterSigningText = computed(() => {
   return offer?.value?.product?.signPageTexts?.afterSigning || '';
  });

  const clearSignature = () => {
   signature1.value.clear()
  }

  const validateSignature = () => {
   signatureError.value = offer?.value.eSignatureType === "WET" ? signature1.value.isEmpty() : false
  }

  const signOffer = async () => {
   signatureError.value = false;
   if (offer?.value.eSignatureType === "NONE" || !signature1.value.isEmpty()) {
    await dispatch('signOffer', {
     token: params.token,
     tenant: params.tenant,
     bankAccountNumber: offer.value.relation.bankAccountNumber,
     debtorName: offer.value.relation.debtorName,
     signatureData: offer?.value.eSignatureType === "WET" ? signature1.value.save('image/svg+xml') : "",
    });
   } else {
    signatureError.value = true;
   }
  }

  const openInNewTab = (url) => {
   // Controleer of de URL is opgegeven
   if (!url) {
    console.error('Geen URL opgegeven');
    return;
   }
   // Open de URL in een nieuw tabblad
   window.open(url, '_parent');
  }

  const pay = async () => {
   await dispatch('generatePayLink', {
    tenant: params.tenant,
    token: params.token,
    openLink: openInNewTab,
   });
  }

  const handleFileUploadCancel = () => {
   fileUpload.value.type = 'CUSTOMERUPLOAD';
   fileList.value = [];
   showFileUploadRef.value = false;
  };

  const showFileUpload = () => {
   showFileUploadRef.value = true;
  };

  const uploading = ref(false);
  const beforeUpload = (file) => {
   fileList.value = [...fileList.value, file];
   return false;
  };

  const handleFileRemove = (file) => {
   const index = fileList.value.indexOf(file);
   const newFileList = fileList.value.slice();
   newFileList.splice(index, 1);
   fileList.value = newFileList;
  };

  const handleUpload = async () => {
   let formData = new FormData();
   formData.append("file", fileList.value[0]);
   formData.append("type", 'CUSTOMERUPLOAD');
   await dispatch('uploadFile', {formData: formData, token: params.token});
   await handleFileUploadCancel();
  }

  onBeforeUnmount(() => {
   dispatch('cleanOffer');
  });

  onMounted(async () => {
   await dispatch('cleanOffer');
   await dispatch('getOffer', params);
   const viewerConfig = {
    embedMode: 'SIZED_CONTAINER',
    showPageControls: true,
   }

   // Adobe PDF Embed API ties each Client ID to a fixed allowlist of domains,
  // so we pick the right key based on where the app is currently served from.
  const adobePdfClientIds = {
   'mijnaanbod.online': '022bb745086b42d288c5970e2ee09925',
   'uwaanbod.online': 'c09c49937c4043cb9d55dab5cdac87f9',
   'app.contrackt.cloud': 'c09c49937c4043cb9d55dab5cdac87f9',
  };
  const defaultAdobePdfClientId = 'c09c49937c4043cb9d55dab5cdac87f9';
  const currentHostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const adobePdfClientId = adobePdfClientIds[currentHostname] || defaultAdobePdfClientId;

  setTimeout(() => {
    // eslint-disable-next-line no-undef
    const adobeDCView = new AdobeDC.View({
     clientId: adobePdfClientId,
     divId: 'adobe-dc-view',
    })

    adobeDCView.previewFile({
     content: {
      location: {
       url: `${process.env.VUE_APP_API_ENDPOINT}${params.tenant}/offer/${params.token}/pdf`,
      },
     },
     metaData: {
      /* file name */
      fileName: `Aanbod.pdf`,
     },
    }, viewerConfig)
   }, 500)

  });

  return {
   offer,
   loadingOffer,
   loadingOfferError,
   sigState,
   clearSignature,
   signature1,
   loadingSignOffer,
   signOffer,
   Aom,
   approvals,
   checkCheckBox,
   signatureError,
   validateSignature,
   params,
   apiEndpoint,
   showFileUploadRef,
   handleFileUploadCancel,
   showFileUpload,
   uploading,
   beforeUpload,
   fileUpload,
   fileList,
   handleFileRemove,
   handleUpload,
   loadingFileUpload,
   pay,
   loadingPayOffer,
   beforeSigningText,
   afterSigningText,
  };
 },
});

export default Sign;
</script>

<style>

.signature canvas {
 width: 450px;
 height: 200px;
}

.checkbox-group .ant-form-item-control-input {
 min-height: 0px !important;
}
</style>
<style>
.pdfobject-container {
 height: 30rem;
 border: 1rem solid rgba(0, 0, 0, .1);
}
</style>
